import { useEnableFlasher } from './useEnableFlasher';

import { useAppSelector } from 'features/app/hooks';
import {
  isTwoLineVcoSelector,
  isVcoRequestedSelector,
} from 'features/vco/store';
import { isTwoLineVcoConnectedSelector } from 'features/call/call-hearing/store';
import { isAcceptingUserSelector } from 'features/teaming/teaming-base/store';

export const useIsThreeDotsMenuVisible = () => {
  const isAcceptingUser = useAppSelector(isAcceptingUserSelector);
  const isTwoLineVcoEnabled = useAppSelector(isTwoLineVcoSelector);
  const isVcoRequested = useAppSelector(isVcoRequestedSelector);
  const isTwoLineVcoConnected = useAppSelector(isTwoLineVcoConnectedSelector);
  const [showEnableFlasher] = useEnableFlasher();

  // Check if VCO menu item would be available
  const showAddVco2Line = !isTwoLineVcoEnabled && !isVcoRequested;
  const hasVcoMenuItem = showAddVco2Line && !isTwoLineVcoConnected;

  // Check if flasher menu item would be available
  const hasFlasherMenuItem = showEnableFlasher;

  // The menu should be visible if:
  // 1. User is not accepting (original condition)
  // 2. AND there's at least one menu item available
  const isThreeDotsMenuVisible =
    !isAcceptingUser && (hasVcoMenuItem || hasFlasherMenuItem);

  return isThreeDotsMenuVisible;
};
